import { Directive, ElementRef, HostListener, Renderer2, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPanFormatter]'
})
export class PanFormatterDirective {
  private _enabled = true;

  // Optional input; defaults to true.
  @Input()
  set useSpaces(value: boolean | string | undefined) {
    this._enabled = (value === undefined || value === '' || value === true || value === 'true');
    this.reformatInput();
  }

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
    private control: NgControl
  ) {}

  @HostListener('input')
  onInput(): void {
    this.reformatInput();
  }

  private reformatInput(): void {
    const inputEl = this.el.nativeElement;
    const currentValue = inputEl.value;
    const cursorPos = inputEl.selectionStart || 0;

    // Remove non-digit characters.
    const digits = currentValue.replace(/\D/g, '');

    // Count digits before the current cursor position.
    let digitsBeforeCursor = 0;
    for (let i = 0; i < cursorPos; i++) {
      if (/\d/.test(currentValue[i])) {
        digitsBeforeCursor++;
      }
    }

    // Apply formatting if enabled.
    const newValue = this._enabled ? digits.replace(/(\d{4})(?=\d)/g, '$1 ') : digits;

    // Update form control and DOM.
    if (this.control?.control) {
      this.control.control.setValue(newValue, { emitEvent: false });
    }
    this.renderer.setProperty(inputEl, 'value', newValue);

    // Calculate and restore the new cursor position.
    let newCursorPos = 0;
    if (this._enabled) {
      let digitCount = 0;
      while (newCursorPos < newValue.length && digitCount < digitsBeforeCursor) {
        if (/\d/.test(newValue[newCursorPos])) {
          digitCount++;
        }
        newCursorPos++;
      }
    } else {
      newCursorPos = digitsBeforeCursor;
    }
    inputEl.setSelectionRange(newCursorPos, newCursorPos);
  }
}
